import axios from "axios"
import constants from "@/helpers/constants"
import moment from "moment"
import store from "@/store/index";
import router from '@/router/index'

const axiosClient = () => {
    const defaultOptions = {
        baseURL: window.$settings.userApiBaseUrl
    };

    // Create instance
    const instance = axios.create(defaultOptions);

    // Set the AUTH token for any request
    instance.interceptors.request.use(function (config) {
        config.withCredentials = true; // To send cookies with Axios, you must set the withCredentials property to true
        
        // const token = store.state.sid;
        // console.debug("axiosClient - token in store", token)
        // config.headers.Authorization = token ? `Bearer ${token}` : '';

        return config;
    });

    instance.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        //Turn all rejects into resolves
        //To determine an API call is successfull, check the existance of response.data
        //Else, response = error message

        console.debug("intercepted error response", error, error.response)
        const errorRes = error.response

        //Extract error messages for various status code - 500, 400 and 404 or validation objects
        let errorMessage = "Please try again later."

        if (errorRes && errorRes.data) {
            const errorData = errorRes.data;

            if (errorData) {
                if (errorData.status === 400) {
                    errorMessage = Object.values(errorData.errors)[0][0]
                }
                else if (errorData.status === 403) {
                    errorMessage = errorData.detail;
                }
                else if (errorData.status === 401) {
                    //Handle 401 - unauthorized status code
                  errorMessage = window.$msg.reloginRequired
                }
            }
        }

        console.debug("errorMessage", errorMessage)

        return Promise.resolve(errorMessage);
        // return Promise.resolve(error.response);
    });

    return instance;
};

export default {
    casAuth(currentRouteName) {
        const casAuth = window.$settings.casAuth;
        const casAuthState = Math.random().toString(36).substring(2, 10); //make state parameter value dynamic 
        // console.debug("currentRouteName", currentRouteName);

        // //Store current URL before going to CAS auth page
        // if (currentRouteName && typeof currentRouteName === "string") {
        //     store.commit("updatePreCasAuthState", {
        //         routeName: currentRouteName,
        //         time: moment()
        //     });
        // }
        // else {
        //     store.commit("updatePreCasAuthState", null);
        // }

        // const params = new URLSearchParams({
        //     applicationid: casAuth.client_id,
        //     service: casAuth.redirect_uri,
        // });

        store.commit("updateCasAuthState", casAuthState);

         const params = new URLSearchParams({
            response_type: casAuth.response_type,
            client_id: casAuth.client_id,
            redirect_uri: casAuth.redirect_uri,
            scope: casAuth.scope.trim(),
            state: store.state.casAuthState, //use dynamic state value from store
            applicationId: casAuth.applicationId,
        });

        const casAuthUrl = casAuth.endpoint + "?" + params.toString();
        window.location.href = casAuthUrl;

        console.log("casAuthUrl", casAuthUrl);
    },
    async login(code, clientLoginUrl, branchId) {
        setTimeout(() => {
            this.loading(true)
        }, 1)

        const mode = this.getModeRaw();

        const response = await axiosClient().post(window.$settings.loginEnpoint, {
            Mode: mode,
            authorizationCode: code,
            clientLoginUrl: clientLoginUrl
        });

        setTimeout(() => {
            this.loading(false)
        }, 2)

        // console.debug("CAS login response", response)
        return response;
    },
    async logout(afterLogoutCallback, branchId) {
        //logout public API for OTP mobile and email
        const mode = this.getModeRaw();
        if (
            store.state.accountInfo?.accountType === constants.accountType.EmailLoginUser ||
            store.state.accountInfo?.accountType === constants.accountType.MobileLoginUser
        ) {
            await axiosClient().post(window.$settings.otpLogoutEndpoint, {
                Mode: mode
            });

            if (afterLogoutCallback) {
                afterLogoutCallback();
            }

            //TODO : Better logic that can cater/handle if both visit booking and gantry access qr enabled
            if (store.state.locationInfoFromUrl) {
                router.push("/login/emailmobilelogin")
            }
            else {
                router.push("/")
            }
        } else {
            //logout public API and CAS
            await axiosClient().post(window.$settings.logoutEnpoint, {
                Mode: mode
            });

            if (afterLogoutCallback) {
                afterLogoutCallback();
            }

            this.casLogout();
        }
    },
    casLogout() {
        //Logout CAS only
        const casAuth = window.$settings.casAuth;

        const params = new URLSearchParams({
            service: casAuth.redirect_uri,
        });

        const casAuthUrl = casAuth.logoutEndpoint + "?" + params.toString();
        window.location.href = casAuthUrl;
    },
    async getAccountInfo() {
        setTimeout(() => {
            this.loading(true)
        }, 1)

        const response = await axiosClient().get(window.$settings.getAccountInfoEndpoint);

        setTimeout(() => {
            this.loading(false)
        }, 2)

        // console.debug("getAccountInfo response", response);
        return response;
    },
    async checkIn(bookingId, autoCheckIn, branchId, silent) {
        if (!silent) {
            this.loading(true)
        }

        const mode = this.getMode(branchId);

        const response = await axiosClient().post(window.$settings.checkInEndpoint, {
            Mode: mode,
            BookingId: bookingId,
            AutoCheckIn: autoCheckIn
        })

        this.loading(false, true)

        // console.debug("checkIn response", response);
        return response;
    },
    async extend(bookingId, branchId) {
        this.loading(true)

        const mode = this.getMode(branchId);

        const response = await axiosClient().post(window.$settings.extendEndpoint, {
            Mode: mode,
            BookingId: bookingId
        })

        this.loading(false, true)

        // console.debug("Extend response", response);
        return response;
    },
    async cancel(isVisitBooking, bookingId, cancelReasonCode, branchId) {
        this.loading(true)

        const mode = this.getMode(branchId);

        const body = {
            mode,
            bookingId,
            CancelReason: cancelReasonCode
        }

        //Visit booking has been updated to use the PATCH verb, so does seat booking
        const endpoint = isVisitBooking ? window.$settings.cancelVisitEndpoint : window.$settings.cancelEndpoint;
        const response = await axiosClient().patch(endpoint, body);

        this.loading(false, true)

        // console.debug("Cancel response", response);
        return response;
    },
    async search(branchId, areaId, startTime, durationInMinutes, seatCode) {
        this.loading(true)

        const mode = this.getMode(branchId);

        const response = await axiosClient().get(window.$settings.searchEndpoint, {
            params: {
                Mode: mode,
                BranchId: branchId,
                AreaId: areaId,
                StartTime: startTime,
                DurationInMinutes: durationInMinutes,
                SelectedSeatCode: seatCode
            }
        })

        const revertStatusBarColor =
            response &&
            response.data &&
            response.data.areas &&
            response.data.areas.length;

        this.loading(false, !revertStatusBarColor)

        // console.debug("Search response", response);
        return response;
    },
    async searchAvailableVisitCapacity(branchId, pax, startTime, durationInMinutes) {
        this.loading(true)

        const mode = this.getMode(branchId);

        const response = await axiosClient().get(window.$settings.searchAvailableVisitCapacityEndpoint, {
            params: {
                mode,
                branchId,
                pax,
                startTime,
                durationInMinutes
            }
        })

        const revertStatusBarColor =
            response &&
            response.data &&
            response.data.visitCapacity;

        this.loading(false, !revertStatusBarColor)

         // console.debug("searchAvailableVisitCapacity response", response);
        return response;
    },
    async book(areaId, startTime, durationInMinutes, branchId, seatCode) {
        this.loading(true)

        const mode = this.getMode(branchId);

        const response = await axiosClient().post(window.$settings.bookEndpoint, {
            Mode: mode,
            AreaId: areaId,
            StartTime: startTime,
            DurationInMinutes: durationInMinutes,
            SeatCode: seatCode
        })

        this.loading(false, true)

        // console.debug("Book response", response);
        return response;
    },
    async bookVisit(branchId, startTime, durationInMinutes, pax) {
        this.loading(true)

        const mode = this.getMode(branchId);

        const response = await axiosClient().post(window.$settings.bookVisitEndpoint, {
            mode,
            branchId,
            startTime,
            durationInMinutes,
            pax
        })

        this.loading(false, true)

        // console.debug("bookVisit response", response);
        return response;
    },
    async requestOtp(channelId, value) {
        this.loading(true)

        const mode = this.getModeRaw();

        const response = await axiosClient().post(window.$settings.requestOtpEndpoint, {
            channelId,
            value,
            mode
        })

        this.loading(false, true)

        // console.debug("requestOtp response", response);
        return response;
    },
    async validateOtp(channelId, value, otp) {
        this.loading(true)

        const mode = this.getModeRaw();

        const response = await axiosClient().patch(window.$settings.otpLoginEndpoint, {
            channelId,
            value,
            otp,
            mode
        })

        this.loading(false, true)

        // console.debug("validateOtp response", response);
        return response;
    },
    async getGantryAccessQr() {

        const mode = this.getModeRaw();

        const response = await axiosClient().get(window.$settings.getGantryAccessQrEndpoint, {
            params: {
                mode
            }
        })

        return response;
    },
    getMode(branchId) {
        const storeMode = store.getters.mode

        if (storeMode && branchId &&
            (storeMode.mode === constants.mode.OnsiteModeQrCode ||
                storeMode.mode === constants.mode.OnsiteModeGps) &&
            storeMode.branchId === branchId) {

            // console.debug("storeMode", storeMode.mode)
            return storeMode.mode
        }

        // console.debug("storeMode", constants.mode.OffsiteMode)
        return constants.mode.OffsiteMode
    },
    getModeRaw() {
        return store.getters.mode.mode
    },
    loading(show, notRevertStatusBarColor) {
        store.commit("updateLoading", { show: show, notRevertStatusBarColor: notRevertStatusBarColor })
    },
    async searchSeatAvailability(branchCode, areaId) {
        this.loading(true)

        //const mode = this.getMode(branchId);
        const mode = this.getMode(branchCode);
        const response = await axiosClient().get(window.$settings.searchSeatAvailability, {
            params: {
                Mode: mode, 
                BranchCode: branchCode,
                AreaId: areaId
            }
        })

        const revertStatusBarColor =
            response &&
            response.data &&
            response.data.areas &&
            response.data.areas.length;

        this.loading(false, !revertStatusBarColor)

        return response;
    }
}
